import { render, staticRenderFns } from "./remarkList.vue?vue&type=template&id=64cda2da&scoped=true"
import script from "./remarkList.vue?vue&type=script&lang=js"
export * from "./remarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cda2da",
  null
  
)

export default component.exports